export const computeStoresWithVariantLink = (
  stores,
  recipeVariants,
  currentVariantId,
  { disableUnlinkedStores = false } = {},
) => {
  const variantByStoreId = recipeVariants.reduce((result, variant) => {
    if (variant.id === currentVariantId) {
      return result;
    }

    const storeIds = variant.storeIds ?? [];

    storeIds.forEach((storeId) => {
      result[storeId] = variant;
    });

    return result;
  }, {});

  const storeIdsInAnyVariant = recipeVariants.reduce((result, variant) => {
    (variant.storeIds ?? []).forEach((storeId) => {
      result.add(storeId);
    });

    return result;
  }, new Set());

  return stores.map((store) => {
    const linkedVariant = variantByStoreId[store.id];
    const isLinkedToOtherVariant = !!linkedVariant;
    const isLinkedToMainRecipe = !storeIdsInAnyVariant.has(store.id);

    return {
      ...store,
      isLinkedToOtherVariant,
      linkedVariantName: linkedVariant?.name ?? null,
      isDisabled: disableUnlinkedStores && !isLinkedToOtherVariant,
      // In the main recipe modal the main recipe stores are the disabled items — no self-link icon.
      showLinkIcon: isLinkedToOtherVariant || (isLinkedToMainRecipe && !disableUnlinkedStores),
    };
  });
};
